import questions from '../lib/libraries/questions.json'

const UPDATE_TARGET_LIST = 'scratch-gui/targets/UPDATE_TARGET_LIST';
const HIGHLIGHT_TARGET = 'scratch-gui/targets/HIGHLIGHT_TARGET';
const ACTIVE_ID = 'scratch-gui/targets/ACTIVE_ID';
const TIP_TIME = 'scratch-gui/targets/TIP_TIME';
const HELPDATA = 'scratch-gui/scratchHelp/helpData';
const SETHISTORY = 'scratch-gui/targets/question_history';
const SETQUESTION = 'scratch-gui/targets/question';


const initialState = {
    sprites: {},
    stage: {},
    robot: {},
    highlightedTargetId: null,
    highlightedTargetTime: null,
    activeId: null,
    tipTime: null,
    helpData: {},
    questions: {
        showquestion: false,
        list: questions
    },
    questionHistory: []
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
        case UPDATE_TARGET_LIST:
            return Object.assign({}, state, {
                sprites: action.targets
                    .filter(target => !target.isStage && !target.isRobot)
                    .reduce(
                        (targets, target, listId) => Object.assign(
                            targets,
                            { [target.id]: { order: listId, ...target } }
                        ),
                        {}
                    ),
                stage: action.targets
                    .filter(target => target.isStage)[0] || {},
                robot: action.targets
                    .filter(target => !target.isStage && target.isRobot)
                    .reduce(
                        (targets, target, listId) => Object.assign(
                            targets,
                            { [target.id]: { order: listId, ...target } }
                        ),
                        {}
                    ),
                editingTarget: action.editingTarget
            });
        case HIGHLIGHT_TARGET:
            return Object.assign({}, state, {
                highlightedTargetId: action.targetId,
                highlightedTargetTime: action.updateTime
            });
        case ACTIVE_ID:
            return Object.assign({}, state, {
                activeId: action.activeId
            });
        case TIP_TIME:
            return Object.assign({}, state, {
                tipTime: action.tipTime
            });
        case HELPDATA:
            return Object.assign({}, state, {
                helpData: action.helpData
            });
        case SETQUESTION:
            return Object.assign({}, state, {
                questions: { ...state.questions, showquestion: action.showquestion }
            });
        case SETHISTORY:
            return Object.assign({}, state, {
                questionHistory: action.history
            });
        default:
            return state;
    }
};
const updateTargets = function (targetList, editingTarget) {
    return {
        type: UPDATE_TARGET_LIST,
        targets: targetList,
        editingTarget: editingTarget,
        meta: {
            throttle: 30
        }
    };
};
const highlightTarget = function (targetId) {
    return {
        type: HIGHLIGHT_TARGET,
        targetId: targetId,
        updateTime: Date.now()
    };
};

const setActiveId = function (activeId) {
    return {
        type: ACTIVE_ID,
        activeId: activeId,
    };
}

const setTipTime = function (tipTime) {
    return {
        type: TIP_TIME,
        tipTime: tipTime,
    };
}
const setHelpData = function (helpData) {
    return {
        type: HELPDATA,
        helpData: helpData,
    };
}
const setHostory = function (history) {
    return {
        type: SETHISTORY,
        history: history,
    };
}

const setQuestion = function (showquestion) {
    return {
        type: SETQUESTION,
        showquestion: showquestion
    }
}
export {
    reducer as default,
    initialState as targetsInitialState,
    updateTargets,
    highlightTarget,
    setActiveId,
    setTipTime,
    setHelpData,
    setHostory,
    setQuestion
};
